import React, { useMemo } from "react";
import { usePlayers } from "../../providers/PlayersProvider";
import PlayersList from "../../components/PlayersList/PlayersList";
import CustomCard from "../../components/CustomCard/CustomCard";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Player } from "../../types";

const NotComers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { players, loading: playersLoading } = usePlayers();

  const playersWithOldMatches = useMemo(() => {
    if (playersLoading) return [];

    const sixtyDaysAgo = new Date();
    sixtyDaysAgo.setDate(sixtyDaysAgo.getDate() - 60);

    return (
      players
        ?.filter((player: Player) => {
          return (
            (!player.lastPlayedAt ||
              new Date(player.lastPlayedAt) < sixtyDaysAgo) &&
            !player.temporary
          );
        })
        .sort((a, b) => a.name.localeCompare(b.name)) || []
    );
  }, [players, playersLoading]);

  return (
    <CustomCard divider={false} title={t("PLAYERS_WITH_OLD_MATCHES")}>
      <Box overflow={"auto"}>
        <PlayersList
          compact
          showRank={false}
          showEntries={false}
          players={playersWithOldMatches}
          loading={playersLoading}
          onPlayerClick={(player) => {
            navigate(`/players/edit/${player.documentId}`);
          }}
        />
      </Box>
    </CustomCard>
  );
};

export default NotComers;
